export default {
  app: {
    about: {
      about: 'O nás',
      pageTitle: 'Elixír Tours - O nás',
    },
  },
};
